import { gql } from 'apollo-boost';

const manyQuery = gql`
  query parents($userId: Int!) {
    parents(userId: $userId) {
      id
      fullName
      type
      email
      phone
      createdAt
      updatedAt
    }
  }
`;

const oneQuery = gql`
  query parent($id: Int!) {
    parent(id: $id) {
      id
      fullName
      type
      email
      phone
      createdAt
      updatedAt
    }
  }
`;

export const createMutation = gql`
  mutation createParent($inputData: ParentInputType!) {
    createParent(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateParent($id: Int!, $inputData: ParentInputType!) {
    updateParent(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteParent($id: Int!) {
    deleteParent(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

const PARENTS = {
  manyQuery,
  oneQuery,
  createMutation,
  updateMutation,
  deleteMutation,
};

export default PARENTS;
